<template>
  <Toast></Toast>
  <Dialog
    v-model:visible="mostarModal"
    :style="{ width: '550px' }"
    header="Pago de comisiones"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12" v-if="cargandoComponente">
      <div class="p-fluid formgrid grid" v-if="permitirPago">
        <div class="field col-12 md:col-12 text-center">
          <h2>
            <strong>{{ data_pago.nombre_usuario }}</strong>
          </h2>
          <h4>
            A pagar:
            <span class="text-red-500 font-bold">{{
              convertirNumeroGermanicFormat(data_pago.total_a_cobrar_comision) +
              " Bs."
            }}</span>
          </h4>
        </div>
        <div class="field col-12 md:col-12" style="background-color: #f2f2f2">
          <p>
            <i class="pi pi-info-circle text-blue-700 font-bold mr-1"></i>
            <strong class="text-blue-700 font-bold">NOTA: </strong>
            <span style="font-size: 14px">
              El Pago se registrará como un
              <strong style="color: red">"EGRESO"</strong> en Caja.
            </span>
          </p>
        </div>
        <div class="field col-12 md:col-12" v-if="mensaje_saldo_caja">
          <span>
            <strong
              ><i class="pi pi-exclamation-triangle text-red-500"></i>
              ADVERTENCIA:</strong
            >
          </span>
          <div class="p-inputgroup">
            <span class="text-blue-850 font-bold" style="font-size: 13px">
              Pagar hasta dejar Caja en 0.00 Bs.
            </span>
            <Checkbox
              v-model="data_pago.pagar_hasta_caja_cero"
              :binary="true"
              class="p-mr-2"
            />
          </div>
        </div>
        <div class="field col-12 md:col-6" v-if="mostrar_fecha_venta">
          <strong>FECHA DE PAGO: </strong>
          <div class="p-inputgroup">
            <Checkbox
              v-model="fecha_comision_diferente"
              :binary="true"
              class="ml-1 mr-2 mt-1"
              v-tooltip.top="'Marque si la fecha es diferente a la actual'"
            />
            <InputText
              class="p-inputtext-sm"
              :disabled="!fecha_comision_diferente"
              v-model="data_pago.fecha"
              type="date"
              :max="new Date().toISOString().split('T')[0]"
            />
          </div>
        </div>

        <!-- MÉTODO DE PAGO -->
        <div class="field col-12 md:col-6">
          <label for="metodo_pago"><strong>MÉTODO DE PAGO:</strong></label>
          <Dropdown
            id="metodo_pago"
            v-model="metodo_pagoSelect"
            :options="metodo_pagos"
            optionLabel="nombre"
            class="w-full"
            optionValue="id"
          />
        </div>

        <!-- MONTO MÉTODO DE PAGO (QR, TARJETA, ETC) -->
        <div class="field col-12 md:col-6" v-if="metodo_pagoSelect != 1">
          <label for=""
            ><strong>MONTO {{ nombreMetodoPago }}:</strong></label
          >
          <InputNumber
            v-model="a_cuenta_metodo_pago"
            :minFractionDigits="2"
            mode="decimal"
            showButtons
            :inputClass="'text-right'"
            :min="0"
            :max="
              parseFloat(data_pago.total_a_cobrar_comision - a_cuenta_efectivo)
            "
          />
        </div>

        <!-- MONTO EFECTIVO -->
        <div class="field col-12 md:col-6">
          <span><strong>EFECTIVO: </strong> </span>
          <InputNumber
            v-model="a_cuenta_efectivo"
            :min="0"
            :max="
              parseFloat(
                data_pago.total_a_cobrar_comision - a_cuenta_metodo_pago
              )
            "
            :minFractionDigits="2"
            :maxFractionDigits="2"
            :showButtons="true"
            locale="de-ED"
            :inputClass="'text-right'"
          />
        </div>

        <!-- OBSERVACIÓN -->
        <div class="field col-12 md:col-12">
          <label for=""><strong>OBSERVACIÓN:</strong></label>
          <Textarea
            v-model="data_pago.observacion"
            placeholder="Observación"
            autoResize
            rows="1"
          />
        </div>
      </div>
      <div class="grid" v-else>
        <Message class="col-12" :severity="'info'" :closable="false">
          <div class="flex align-items-center justify-content-center">
            <span> PARA REALIZAR PAGOS DEBE ABRIR LA CAJA </span>
            <Button
              label="APERTURAR CAJA"
              class="p-button-success p-button-lg ml-3"
              icon="pi pi-lock-open"
              v-tooltip.top="'Abrir Caja'"
              @click="this.$router.push({ name: 'caja' })"
            />
          </div>
        </Message>
      </div>
    </div>
    <div v-else>
      <div class="grid">
        <h3 class="col-12">Verificando caja ...</h3>
        <ProgressSpinner
          style="width: 50px; height: 50px"
          strokeWidth="8"
          fill="var(--surface-ground)"
          animationDuration=".5s"
          class="col-12"
        />
      </div>
    </div>
    <template #footer>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
      />
      <Button
        label="REALIZAR PAGO"
        icon="pi pi-save"
        class="p-button-info p-button-lg"
        @click="savePagoComision"
        :loading="loading"
        :disabled="!permitirPago"
      />
    </template>
  </Dialog>
</template>
<script>
import ComisionService from "@/service/ComisionService";
import CajaService from "@/service/CajaService";
import MetodoPagoService from "@/service/MetodoPagoService.js";

export default {
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    pagos_comisiones: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mostrar_fecha_venta: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostarModal: this.show,
      data_pago: this.pagos_comisiones,
      loading: false,
      permitirPago: false,
      cargandoComponente: false,
      mensaje_saldo_caja: false,
      fecha_comision_diferente: false,
      metodo_pagoSelect: 1,
      metodo_pagos: [],
      a_cuenta_metodo_pago: 0,
      a_cuenta_efectivo: 0,
    };
  },
  comisionService: null,
  cajaService: null,
  metodoPagoService: null,
  created() {
    this.comisionService = new ComisionService();
    this.cajaService = new CajaService();
    this.metodoPagoService = new MetodoPagoService();
  },
  mounted() {
    this.verificarCajaAbierta();
    this.getMetodoPagos();
  },
  computed: {
    nombreMetodoPago() {
      const metodo = this.metodo_pagos.find(
        (m) => m.id === this.metodo_pagoSelect
      );
      return metodo ? metodo.nombre : "";
    },
  },
  methods: {
    getMetodoPagos() {
      this.metodoPagoService.getAllMetodoPagos().then((response) => {
        this.metodo_pagos = response.metodo_pagos;
      });
    },
    imprimirMovimientos(id) {
      this.cajaService.imprimirMovimientosPDF(id).then(() => {});
    },
    verificarCajaAbierta() {
      this.cajaService.verificarCajaAbierta().then((response) => {
        if (response.caja.length > 0) {
          this.caja = response.caja[0];
          this.sucursal_id = response.caja[0].sucursal_id;
          this.permitirPago = true;
        } else {
          this.permitirPago = false;
        }
        this.cargandoComponente = true;
      });
    },
    ocultarDialog() {
      this.mostarModal = false;
      this.$emit("closeModal");
      this.mensaje_saldo_caja = false;
      this.loading = false;
      this.fecha_comision_diferente = false;
      this.metodo_pagoSelect = 1;
      this.a_cuenta_metodo_pago = 0;
      this.a_cuenta_efectivo = 0;
    },
    savePagoComision() {
      // Validar que el monto total sea mayor a 0
      const montoTotal =
        parseFloat(this.a_cuenta_efectivo) +
        parseFloat(this.a_cuenta_metodo_pago);

      if (montoTotal <= 0) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe ingresar un monto mayor a 0",
          life: 3000,
        });
        return;
      }

      this.loading = true;
      let datos = {
        ...this.data_pago,
        mostrar_fecha_venta: this.mostrar_fecha_venta,
        fecha_comision_diferente: this.fecha_comision_diferente,
        metodo_pago_id: this.metodo_pagoSelect,
        a_cuenta_metodo_pago: this.a_cuenta_metodo_pago,
        a_cuenta_efectivo: this.a_cuenta_efectivo,
        egreso: montoTotal,
      };

      this.comisionService
        .savePagoComision(datos)
        .then((data) => {
          if (data.success === false) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: data.message,
              life: 3000,
            });
            this.loading = false;
            this.mensaje_saldo_caja = true;
            return;
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Exito",
              detail: data.message,
              life: 3000,
            });
            if (data.id_mov_caja !== null) {
              this.imprimirMovimientos(data.id_mov_caja);
            }

            this.loading = false;
            this.mensaje_saldo_caja = false;
            this.ocultarDialog();
            this.$emit("actualizarListado");
          }
        })
        .catch((data) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: data.message,
            life: 3000,
          });
          this.loading = false;
          this.mensaje_saldo_caja = true;
        });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numero);
    },
  },
  watch: {
    show(val) {
      this.mostarModal = val;
    },
    pagos_comisiones(val) {
      this.data_pago = val;
      this.a_cuenta_efectivo = parseFloat(
        this.data_pago.total_a_cobrar_comision
      );
      this.a_cuenta_metodo_pago = 0;
    },
  },
};
</script>
